"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitToolSuccess = emitToolSuccess;
exports.emitToolError = emitToolError;
const events_1 = require("../../app/dist/telemetry/events");
/**
 * Dispatcher-seam telemetry (design decision B): the MCP `CallTool` handler is
 * the single point every `loom_*` write funnels through — from the Claude Code
 * agent AND the VS Code extension (an MCP client). We emit here, keyed off the
 * wire tool name, so one wrapper instruments all of it. The app-layer taxonomy
 * (packages/app/src/telemetry/events) remains the only emitter; this table is
 * just the call site.
 */
/** Wire tool name → the loop event it represents, beyond the generic command_invoked. */
const LOOP_EVENT = {
    // chat phase — a new thinking surface is opened (creation only; appends are noise).
    loom_create_chat: (t) => (0, events_1.trackChatCreated)(t),
    // {generate} phase — a structured doc is born (Claude Code create* path)…
    loom_create_idea: (t) => (0, events_1.trackDocGenerated)(t, 'idea'),
    loom_create_design: (t) => (0, events_1.trackDocGenerated)(t, 'design'),
    loom_create_plan: (t) => (0, events_1.trackDocGenerated)(t, 'plan'),
    loom_create_req: (t) => (0, events_1.trackDocGenerated)(t, 'req'),
    // …and the sampling-fallback generate* path.
    loom_generate_idea: (t) => (0, events_1.trackDocGenerated)(t, 'idea'),
    loom_generate_design: (t) => (0, events_1.trackDocGenerated)(t, 'design'),
    loom_generate_plan: (t) => (0, events_1.trackDocGenerated)(t, 'plan'),
    loom_generate_req: (t) => (0, events_1.trackDocGenerated)(t, 'req'),
    // {refine} phase.
    loom_refine_idea: (t) => (0, events_1.trackDocRefined)(t, 'idea'),
    loom_refine_design: (t) => (0, events_1.trackDocRefined)(t, 'design'),
    loom_refine_plan: (t) => (0, events_1.trackDocRefined)(t, 'plan'),
    // loop transitions.
    loom_start_plan: (t) => (0, events_1.trackPlanStarted)(t),
    loom_complete_step: (t) => (0, events_1.trackStepCompleted)(t),
    loom_close_plan: (t) => (0, events_1.trackPlanDone)(t),
};
/**
 * Emit telemetry for a tool call that succeeded: always `command_invoked` (coarse
 * "which tools fire"), plus the loop event if this tool maps to one.
 */
function emitToolSuccess(telemetry, toolName) {
    (0, events_1.trackCommandInvoked)(telemetry, toolName);
    LOOP_EVENT[toolName]?.(telemetry);
}
/**
 * Emit an `error` event for a tool call that threw. Sends only the tool name and
 * the error's constructor name — never the message, which could carry content.
 */
function emitToolError(telemetry, toolName, err) {
    const errorClass = err instanceof Error ? err.constructor.name : 'UnknownError';
    (0, events_1.trackError)(telemetry, toolName, errorClass);
}
